import React from "react";
import Chip from "@mui/material/Chip";

const STATUS_COLOR = {
  pending:  "warning",
  approved: "success",
  spam:     "error",
  rejected: "default",
};

export function CommentStatusChip({ status }) {
  return (
    <Chip
      label={status ? status.charAt(0).toUpperCase() + status.slice(1) : "—"}
      color={STATUS_COLOR[status] || "default"}
      size="small"
    />
  );
}
